/*
These functions make sure WordPress
and Foundation play nice together.
*/

var $win = jQuery(window),
  $body = jQuery("body");
  $ = jQuery;


// Remove empty P tags created by WP inside of Accordion and Orbit
jQuery(".accordion p:empty, .orbit p:empty").remove();



jQuery(window).on("load", function () {

  jQuery(".top-bar .menu-bars").on("click", function () {
    jQuery(this).find(".fas").toggleClass("fa-times");
  });
  jQuery(".js-off-canvas-overlay").on("click", function () {
    jQuery(".top-bar .menu-bars .fas").removeClass("fa-times");
  });

  jQuery(".js-subscribe a").on("click", function (e) {
    e.preventDefault();

    var $target = jQuery(this).attr("href");

    jQuery("html, body").animate(
      {
        scrollTop: jQuery($target).offset().top,
      },
      800
    );

    if (jQuery(this).parents(".off-canvas")) {
      jQuery(".js-off-canvas-overlay").trigger("click");
    }
  });



  if ($body.hasClass("home")) {
    var $banner = jQuery(".js-banner"),
      $videos = jQuery(".js-video-list"),
      $releases = jQuery(".js-release-list"),
			$merch = jQuery(".section-merch .wps-items-list");

    setTimeout(function () {
      jQuery("#ae-cform-modal-display-cta-2").trigger("click");
    }, 15000);

    $win = jQuery(window);

    $(window).on("scroll", function () {
      if ($win.scrollTop() > 10) {
        $("#top-bar-menu").addClass("scrolled");
      } else {
        $("#top-bar-menu").removeClass("scrolled");
      }
    });
    

    $banner.slick({
      dots: false,
      fade: true,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 815,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    jQuery(".section-banner").addClass("init");

    $banner.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        $banner.addClass("is-sliding");
      }
    );

    $banner.on("afterChange", function (event, slick, currentSlide) {
      $banner.removeClass("is-sliding");
    });

    $releases.slick({
      slidesToScroll: 3,
      slidesToShow: 3,
      speed: 500,
      cssEase: "ease-in-out",
      useTransform: true,
      dots: false,
      fade: false,
      speed: 700,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $merch.slick({
      slidesToScroll: 3,
      slidesToShow: 3,
      speed: 500,
      cssEase: "ease-in-out",
      useTransform: true,
      dots: false,
      fade: false,
      speed: 700,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.wps-item a').attr('target', '_blank'); 

    if($('.section-videos .article').length === 1) {
      $('.section-videos .js-video-list').addClass('single-video');
      $('.section-videos .video-list').addClass('single-video');
    }

    $('.section-videos .slick-prev').on('click', function(){
      var currentVideo = $('.section-videos .current');
      var prevVideo1 = $('.section-videos .active-1');
      var newCurrentVideo = '';
      if(currentVideo.prev().length > 0) {
        newCurrentVideo = currentVideo.prev();
      } else {
        newCurrentVideo = $('.section-videos .article-video').last();
      }

      $('.article-video').removeClass('active current active-1 active-2'); 
      
      currentVideo.addClass('active active-1');
      prevVideo1.addClass('active active-2');
      newCurrentVideo.addClass('active current')
    })
    
    $('.section-videos .slick-next').on('click', function(){

      var nextVideo = $('.section-videos .active-1');
      var nextVideo2 = $('.section-videos .active-2');
      var nextVideo3 = '';
      if(nextVideo2.next().length > 0) {
        nextVideo3 = nextVideo2.next();
      } else {
        nextVideo3 = $('.section-videos .article-video').first();
      }

      $('.article-video').removeClass('active current active-1 active-2'); 
      
      nextVideo.addClass('active current');
      nextVideo2.addClass('active active-1');
      nextVideo3.addClass('active active-2');
    })


    function scrollDownNav(target) {
      event.preventDefault();
      $('.js-off-canvas-overlay').trigger('click')
      
      if(screen.width >= 1024) {
        $('html,body').animate({scrollTop: $(target).offset().top - 50},'slow');
      } else {
        $('html,body').animate({scrollTop: $(target).offset().top},'slow');
      }
    }
    $('.custom-logo-link').on('click', function(event){
      scrollDownNav('.section-banner')
    });
    $('.nav-music').on('click', function(event){
      scrollDownNav('#music')
    });
    $('.nav-videos').on('click', function(event){
      scrollDownNav('#videos')
    });
 
    $('.nav-tour').on('click', function(event){
    scrollDownNav('#tour')
    });
    $('.nav-about').on('click', function(event){
      scrollDownNav('#about')
    });
    $('.nav-store, .nav-merch').on('click', function(event){
      scrollDownNav('#merch')
    })


    jQuery(".js-intro-arrow").on("click", function (e) {
      e.preventDefault();
  
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(".section-music").offset().top - 64,
        },
        500
      );
    });

    jQuery('.anchor-down').on('click', function(e){
      e.preventDefault();
      var nextSection = jQuery(this).closest('.section').next();

      if(screen.width > 900) {
        var paddingTop = 150;
      } else {
        paddingTop = 0;
      }


      jQuery("html, body").animate(
        {
          scrollTop: jQuery(nextSection).offset().top - paddingTop,
        },
        500
      );

    })

    jQuery(".main-home .section").each(function () {
      var self = jQuery(this);

      jQuery(this).waypoint({
        handler: function (direction) {
          // if(direction == 'down') {
          // }

          // jQuery('.main-home .section').removeClass('show');
          self.addClass("show");
        },
        offset: "50%",
      });
    });

    if ($win.width() < 480) {
      var waypoints = jQuery(".section-about").waypoint({
        handler: function (direction) {
          if (direction == "up") {
            jQuery("#top-bar-menu .logo").removeClass("show");
          } else {
            jQuery("#top-bar-menu .logo").addClass("show");
          }
        },
        offset: "0",
      });
    }
  }
});

if (!$body.hasClass("home")) {
  $(document).ready(function () {
    if ($(".-paginated").length) {
      let initialNumber = $(".-paginated").attr("data-load-more-initial");
      let perPageNumber = $(".-paginated").attr("data-load-more-per-page");

      const totalNumber = $(".-paginated .c-paginated-item").length;

      if (initialNumber) {
        $(
          ".-paginated .c-paginated-item:not(:lt(" + initialNumber + "))"
        ).hide();
        $(".-paginated").addClass("-loaded");
      }

      $(".more-link a").click(function (e) {
        e.preventDefault();

        let countShown = 0;

        $(".-paginated .c-paginated-item").each(function () {
          if (!$(this).is(":visible")) {
            $(this).slideDown();
            countShown++;
          }

          if (countShown >= perPageNumber) {
            return false;
          }
        });

        if ($(".-paginated .c-paginated-item").not(":visible").length === 0) {
          $(this).hide();
        }

        return false;
      });
    }
  });
}

$('.button.js-embed').mouseenter(function(e){
  e.preventDefault();
  $('.release .cell-overlay').removeClass('active');
  $(this).closest('.release').find('.cell-overlay').addClass('active');
})

$('.cell-overlay').mouseleave(function(e){
  e.preventDefault();
  $(this).closest('.cell-overlay').removeClass('active');
})